'use client';

import { useEffect, useRef } from 'react';
import TagManager from 'react-gtm-module';
import { useOptionalRuntimeConfigProvider } from '../../Config/RuntimeConfigProvider';

export type GtmRuntimeConfig = {
	gtmId?: string;
};

export default function RuntimeGoogleTagManager() {
	const isInitialized = useRef(false);
	const gtmRuntimeConfig = useOptionalRuntimeConfigProvider<GtmRuntimeConfig>();

	const isLoading = gtmRuntimeConfig?.isLoading ?? false;
	const gtmId = gtmRuntimeConfig?.config?.gtmId;

	useEffect(() => {
		if (isInitialized.current) {
			return;
		}

		if (!gtmId && isLoading) {
			console.debug('[GTM] Waiting for runtime config...');
			return;
		} else if (!gtmId) {
			console.debug('[GTM] No ID set');
		} else {
			TagManager.initialize({
				gtmId,
			});
			isInitialized.current = true;
			console.debug('[GTM] Initialised');
		}
	}, [gtmId, isLoading]);

	return null;
}
